import Service from "../Service";
const resource = "FacialReconognition/";

export default {
    list(areID, requestID) {
        return Service.post(resource + "list", {}, {
            params: {areID: areID, requestID: requestID },
        });
    },
};